export default {
	API: "https://hmg.barkfinder.suzano.tcsapp.com.br/api"
};